<template>
  <div id="main-content" class="parent-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <template v-if="data">
        <el-row style="padding-top: 20px">
          <table class="bus-list filter-sort-table">
            <tr>
              <th width="5%">#</th>
              <th width="20%" class="input-th">
                <el-input :placeholder="$t('common.full_name')" v-model="filter.fullname"></el-input>
                <Sort :model="sort.fullname" @change="changeSort($event, 'fullname')"></Sort>
              </th>
              <th width="15%" class="input-th">
                <el-input :placeholder="$t('common.romaji')" v-model="filter.romaji"></el-input>
                <Sort :model="sort.romaji" @change="changeSort($event, 'romaji')"></Sort>
              </th>
              <th width="15%" class="input-th">
                <el-input :placeholder="$t('common.furigana')" v-model="filter.furigana"></el-input>
                <Sort :model="sort.furigana" @change="changeSort($event, 'furigana')"></Sort>
              </th>
              <th width="10%" class="input-th">
                {{$t('common.gender')}}
              </th>
              <th width="15%">
                <el-input :placeholder="$t('common.parent_name')" v-model="filter.parent_name"></el-input>
              </th>
              <th>
                <el-button @click="resetFilter"
                           style="margin: 2px;" type="danger">{{ $t('common.reset') }}
                </el-button>
              </th>
            </tr>
            <tr v-for="(item, index) in sortedDataList" :key="item.id" v-show="index >= itemPerPage * (page-1) && index < itemPerPage * page">
              <td>{{ index + 1 }}</td>
              <td>{{  item.fullname ? item.fullname  : '' }}</td>
              <td>{{  item.furigana ? item.furigana : '' }}</td>
              <td>{{  item.romaji ? item.romaji : '' }}</td>
              <td>{{item.gender === 0 ?  $t('common.female') : $t('common.male') }}</td>
              <td>{{item.parent ?  item.parent.name : ''}}</td>
              <td>
                <b-button variant="primary" class="mr-2" @click="onApprove( item)">{{ $t('parent_list.btnApprove') }}</b-button>
                <b-button variant="danger" @click="onRejectStudent(item.id)">{{ $t('parent_list.btnReject') }}</b-button>
              </td>
            </tr>
          </table>
        </el-row>
        <el-row style="padding-top: 15px">
          <el-pagination
              v-show="sortedDataList.length > itemPerPage"
              background
              @current-change="didSelectPage"
              :page-size="itemPerPage"
              layout="prev, pager, next"
              :current-page="page"
              :total="sortedDataList.length">
          </el-pagination>
        </el-row>
      </template>
    </el-col>
  </div>
</template>
<script>
import PageTitle from '@/components/PageTitle'
import {CANNOT_SEND, ITEM_PER_PAGE} from "../../config";
import Sort from "@/components/Sort";
export default {
  name: 'ParentList',
  components: {
    PageTitle, Sort
  },
  data: function () {
    return {
      backLink: `/student`,
      title: 'studentApprove.titleList',
      page: 1,
      CANNOT_SEND: CANNOT_SEND,
      itemPerPage: ITEM_PER_PAGE,
      filter: {
        fullname: '',
        romaji: '',
        furigana: '',
        parent_name: ''
      },
      sort: {
        fullname: '',
        romaji: '',
        furigana: '',
        parent_name: ''
      },
      isBack: false,
      data: null,
      filterTimeout: null
    }
  },
  computed:{
    filteredApproveList: function () {
      let filterName = this.filter.fullname.trim()
      let filterFurigana = this.filter.furigana.trim()
      let filterParent = this.filter.parent_name.trim()
      let filterRomaja = this.filter.romaji.trim()
      return this.data.filter((subDriverItem) => {
        if (filterName && !this.isStringMatched(subDriverItem.fullname, filterName)) {
          return false
        }

        if (filterFurigana && !this.isStringMatched(subDriverItem.furigana, filterFurigana)) {
          return false
        }

        if (filterParent && !this.isStringMatched(subDriverItem.parent.name, filterParent)) {
          return false
        }
        if (filterRomaja && !this.isStringMatched(subDriverItem.romaji, filterRomaja)) {
          return false
        }
        return true
      })
    },
    sortedDataList: function () {
      let sortedDataList = [].concat(this.filteredApproveList)

      sortedDataList.sort((before, after) => {
        if (this.sort.fullname) {
          let sortName = this.standardSort(before, after, 'fullname', 'fullname')
          if (sortName) {
            return sortName
          }
        }

        if (this.sort.furigana) {
          let sortEmail = this.standardSort(before, after, 'furigana', 'furigana')

          if (sortEmail) {
            return sortEmail
          }
        }

        if (this.sort.romaji) {
          let sortPhone = this.standardSort(before, after, 'romaji', 'romaji')

          if (sortPhone) {
            return sortPhone
          }
        }
        return 0
      })

      return sortedDataList
    }
  },
  methods: {
    onApprove(item){
      this.$router.push({path: '/student/detail-wait', query:{sid: item.id}});
    },
    onRejectStudent(studentId){
      this.$prompt(this.$t('msg.contentReject'), this.$t('common.confirm'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('common.cancel'),
        inputPattern: /([^\s])/,
        inputErrorMessage: this.$t('msg.rejectRequired'),
      }).then(({ value }) => {
        let successCallback = (res) =>{
          if(res.status ===200){
            this.retrieveData()
            this.$notify({
              title: this.$t('msg.titleSuccess'),
              message: this.$t('msg.contentRejectStudentSuccess'),
              type: 'success'
            })
          }
        }
        let errorCallback = () => {}
        let content = value
        let payload  = {
          successCallback,
          errorCallback,
          student_id: studentId,
          data : {
            content: content
          }
        }
        this.$store.dispatch('parent/rejectStudent', payload)
      }).catch(() => {
      });
    },
    changeSort (type, field) {
      this.sort[field] = type
      this.sort = Object.assign({}, this.sort)
    },
    standardSort (before, after, model, field) {
      if (this.sort[model] === 'asc') {
        if (before[field] < after[field]) {
          return -1
        }

        if (before[field] > after[field]) {
          return 1
        }
      } else {
        if (before[field] < after[field]) {
          return 1
        }

        if (before[field] > after[field]) {
          return -1
        }
      }

      return 0
    },
    isStringMatched (source, needed) {
      return source.toUpperCase().indexOf(needed.toUpperCase()) !== -1
    },
    didSelectPage: function (e) {
      this.page = e
    },
    resetFilter(){
      let filter = {
        fullname: '',
        furigana: '',
        romaji: '',
        parent_name: ''
      }
      this.filter = filter
    },
    openListApprove(){
      this.$router.push('list-parent-need-approve')
    },
    goToDetailParent(parentId) {
      this.$router.push({path: '/parent/detail', query: {pid: parentId}});
    },
    retrieveData: function () {
      let successCallback = (response) => {
        if(response.status ===200){
          this.data =  response.data.data.data_list
        }
      }
      let errorCallback = () => {}
      let payload ={
        successCallback,
        errorCallback
      }
      this.$store.dispatch('parent/getListStudentWaitApprove', payload)
    },
  },
  created: function () {
    this.retrieveData()
  },

}
</script>